export class LatLngBounds {
  constructor(southWest: LatLng, northEast: LatLng) {
    this.southWest = southWest;
    this.northEast = northEast;
  }
  southWest: LatLng;
  northEast: LatLng;
}

export class LatLng {
  constructor(lat: number, long: number) {
    this.lat = lat;
    this.long = long;
  }
  lat: number;
  long: number;
}
